<div class="ui-schedule">
	@if (scheduleActionButtons(); as scheduleActionButtons) { @if (scheduleActionButtons.length) {
	<div class="push-bottom">
		<lib-button-list
			[buttons]="scheduleActionButtons"
			[mode]="'extendedList'"
			[extendListThreshold]="isMobileOrTabletView() ? 1 : 2"
		></lib-button-list>
	</div>
	} } @if (extendedScheduleContainers().length === 0) {
	<div>
		<lib-message [type]="'noDataOnBody'" [title]="'No schedule is selected'">
			In order to set up plan, you have to select the schedule first
		</lib-message>
	</div>
	} @if (displayMode() === 'edit' && extendedScheduleContainers().length) {
	<lib-card class="push-bottom" [title]="'Schedule'">
		<ui-text-form-field
			[title]="undefined"
			[isRequired]="true"
			[useDebounce]="true"
			[valueAsSignal]="currentTitle"
			[maxLength]="50"
			(requiredValueChange)="handleTitleChanged($event)"
		></ui-text-form-field>
	</lib-card>
	} @if (displayMode() === 'preview') {
	<h2>
		{{ scheduleTitle() }}
	</h2>
	<div libText3>
		{{ authUserIsClient() ? 'Your schedule' : 'Current schedule' }}
	</div>
	} @if (authUserIsTrainer()) {
	<div class="push-top" libFlexRow [libFlexRowAlign]="'center'">
		<div libFlexColumn libFlexFill>
			@if (addContainerScheduleButtons(); as addContainerScheduleButtons) { @if
			(addContainerScheduleButtons.length) {
			<lib-button-list [buttons]="addContainerScheduleButtons" [mode]="'list'"></lib-button-list>
			} }
		</div>

		<div libFlexColumn>
			<lib-checkbox-form-input
				[label]="'Show preview'"
				[checked]="showPreview()"
				(valueChange)="handleShowPreviewChange($event)"
			></lib-checkbox-form-input>
		</div>
	</div>

	}

	<lib-divider class="push-top push-bottom" [layout]="'withContent'">Schedule plan</lib-divider>

	<div [libFlexRow]="true" [libFlexRowGap]="'24px'" [libFlexRowAlign]="'stretch'">
		@for (extendedScheduleContainer of extendedScheduleContainers(); track extendedScheduleContainer.id; let first =
		$first) {
		<div
			libFlexColumn
			[style.width]="calculateFlexWidth(scheduleItemColumnsPerRow(), 24)"
			[id]="extendedScheduleContainer.domId"
		>
			<lib-card
				style="height: 100%"
				[title]="extendedScheduleContainer.title"
				[buttonsMode]="'single'"
				[buttonsExtendedListThreshold]="1"
				[buttons]="extendedScheduleContainer.cardButtons"
			>
				@if (extendedScheduleContainer.assignButtons.length) {
				<div>
					<lib-button-list [buttons]="extendedScheduleContainer.assignButtons"></lib-button-list>
				</div>
				}

				<div class="push-top">
					@if (extendedScheduleContainer.items.length === 0) {
					<div libText5 class="push-top">Free</div>
					} @else { @for (extendedItem of extendedScheduleContainer.items; track extendedItem.id; let first =
					$first; let last = $last; let index = $index) {

					<lib-link [routerLink]="extendedItem.routes.main" [linkStyle]="'noUnderline'">
						<div
							class="ui-schedule-item"
							[class.first]="first"
							[class.last]="last"
							[class.not-first]="index > 0"
						>
							<ng-template [ngTemplateOutlet]="scheduleItemTemplate"></ng-template>
						</div>
					</lib-link>

					<ng-template #scheduleItemTemplate>
						<div>
							<div libFlexRow [libFlexRowGap]="'16px'" [libFlexRowAlign]="'center'">
								@if (extendedItem.avatar) {
								<div libFlexColumn>
									<lib-image
										[alt]="extendedItem.title"
										[imageSize]="'50px'"
										[image]="extendedItem.avatar"
									></lib-image>
								</div>
								} @else { @if (extendedItem.iconType) {
								<div libFlexColumn style="width: 40px">
									<div libFlexRow [libFlexRowAlign]="'center'">
										<div libFlexColumn>
											<lib-icon [type]="extendedItem.iconType"></lib-icon>
										</div>
									</div>
								</div>
								} }
								<div libFlexColumn libFlexFill>
									<div class="ui-schedule-title">
										{{ extendedItem.title }}
									</div>
									@if (extendedItem.data.notes) {
									<div class="ui-schedule-notes" libLineClamp [clampLines]="2">
										{{ extendedItem.data.notes }}
									</div>
									}
								</div>
								@if (displayMode() === 'edit') {
								<div libFlexColumn (click)="handleClickButtonList($event)">
									<lib-button-list
										[mode]="'single'"
										[buttons]="extendedItem.buttons"
									></lib-button-list>
								</div>
								}
							</div>
						</div>
					</ng-template>

					} }
				</div>
			</lib-card>
		</div>
		}
	</div>
</div>
